import { networkService as network } from '@/services'

export const exhibitorEventsService = {
  getExhibitorEventsAll(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/exhibitor-events/all/user/${id}`)
        .then((data) => {
          resolve(data.data)

        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getEventAllExhibitors(eventId) {
    return new Promise((resolve, reject) => {
      network
        .get(`/exhibitor-events/all/event/${eventId}`)
        .then((data) => {
          resolve(data.data)

        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getExhibitorEvent(eventId) {
    return new Promise((resolve, reject) => {
      network
        .get(`/exhibitor-events/${eventId}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  createExhibitorEvent({user, event, bundle, status, boothLogo, boothBanner, boothScreen }) {
    return new Promise((resolve, reject) => {
      const request = {user, event, bundle, status, boothLogo, boothBanner, boothScreen }
      network
        .post(`/exhibitor-events`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  updateExhibitorEvent({ id, user, event, bundle, status}) {
    return new Promise((resolve, reject) => {
      const request = { id, user, event, bundle, status}
      network
        .put(`/exhibitor-events/${id}`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  updateFullExhibitorEvent(payload) {
    return new Promise((resolve, reject) => {

      network
        .put(`/exhibitor-events/${payload.id}`, payload)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getExhibitorEventByUserId({ userId, eventId }) {
    return new Promise((resolve, reject) => {
      network
        .get(`/exhibitor-events/all/user/${userId}`)
        .then((data) => {
          let res = {};

          data.data.forEach((item, index) => {
            if(item.event === eventId) {
              res = item;
            }
          })
          resolve(res)

        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getExhibitorPagesFromTo({ page = 1, take = 10, eventId }) { 
    return new Promise((resolve, reject) => {
      network
        .get(`/exhibitor-events/pages?order=ASC&page=${page}&take=${take}&eventId=${eventId}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },


  saveExhibitorEventLogo(_file, id) {
    let formData = new FormData()
    formData.append("booth-logo", _file)

    return new Promise((resolve, reject) => {
      network
        .post(`/exhibitor-events/booth-logo/${id}`, formData)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },

  saveExhibitorEventBanner(_file, id) {
    let formData = new FormData()
    formData.append("booth-banner", _file)

    return new Promise((resolve, reject) => {
      network
        .post(`/exhibitor-events/booth-banner/${id}`, formData)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },

  saveExhibitorEventScreen(_file, id) {
    let formData = new FormData()
    formData.append("booth-screen", _file)

    return new Promise((resolve, reject) => {
      network
        .post(`/exhibitor-events/booth-screen/${id}`, formData)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },


  deleteExhibitorEvent(id) {
    return new Promise((resolve, reject) => {
      network
        .delete(`/exhibitor-events/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}